import { render } from "./AiCodeReviewHardening.vue?vue&type=template&id=a3a0d6fa&scoped=true"
import script from "./AiCodeReviewHardening.vue?vue&type=script&lang=js"
export * from "./AiCodeReviewHardening.vue?vue&type=script&lang=js"

import "./AiCodeReviewHardening.vue?vue&type=style&index=0&id=a3a0d6fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3a0d6fa"]])

export default __exports__